import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { VCObserverWrapper } from '../vc';
import { interactions } from './common/constants';
import { remove } from './index';
export default class InteractionExtraMetrics {
  constructor() {
    // Store the finished interaction ID (as non-3p interaction)
    _defineProperty(this, "finishedInteractionId", null);
    // independent VC observer, that observes until `custom.post-interaction-logs` event is sent
    _defineProperty(this, "vcObserver", null);
    _defineProperty(this, "sinkHandlerFn", () => {});
  }
  initializeVCObserver(options) {
    this.vcObserver = new VCObserverWrapper({
      ...options,
      isPostInteraction: true
    });
  }
  startVCObserver({
    startTime
  }, interactionId) {
    if (this.eligibleToMeasure(interactionId)) {
      var _this$vcObserver;
      (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 ? void 0 : _this$vcObserver.start({
        startTime
      });
    }
  }
  stopVCObserver() {
    var _this$vcObserver2;
    (_this$vcObserver2 = this.vcObserver) === null || _this$vcObserver2 === void 0 ? void 0 : _this$vcObserver2.stop();
  }

  // Check if the current interaction is eligible for measurement
  eligibleToMeasure(interactionId) {
    const interaction = interactions.get(interactionId);
    return (interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'page_load' || (interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'transition';
  }
  updateFinishedInteractionId(interactionId) {
    if (this.eligibleToMeasure(interactionId)) {
      this.finishedInteractionId = interactionId;
    }
  }
  sinkHandler(fn) {
    this.sinkHandlerFn = fn;
  }
  onInteractionComplete(id, data) {
    if (data.ufoName) {
      var _this$vcObserver3;
      const updatedData = {
        ...data,
        vcObserver: (_this$vcObserver3 = this.vcObserver) !== null && _this$vcObserver3 !== void 0 ? _this$vcObserver3 : undefined
      };
      this.sinkHandlerFn(id, updatedData);
    }
    this.stopVCObserver();
    remove(id);
    this.reset();
  }
  reset() {
    this.finishedInteractionId = null;
  }
  stopAll(id) {
    this.stopVCObserver();
    remove(id);
    this.reset();
  }
}